import React, { useContext } from "react";
// import ListadoContext from "../context/ListadoContext";
// import Select from "../../../components/Select";
// import { image_path_server } from "../../../config";
// import { lightFormat, parseJSON } from "date-fns";
import Default, { Code } from "./columnas/Default";
import FechaC from "./columnas/Fecha";
import SiNo from "./columnas/SiNo";
import Enlace from "./columnas/Enlace";
import Imagen from "./columnas/Imagen";
import Boton from "./columnas/Boton";
import SelectC from "./columnas/SelectC";
import EnlaceOpcional from "./columnas/EnlaceOpcional";
import InputAreaEditable from "./columnas/InputEditableL";
import SiNoEditable from "./columnas/SiNoEditable";
import Toggle from "./columnas/Toggle";
import { TextArea } from "./columnas/TextArea";
import InputTextEditable from "./columnas/InputTextEditable";
import InputDate from "./columnas/InputDate";

import Autocompletar from "../../components/Autocompletar";
import InputFile from "../../components/InputFile";
import VerArchivo from "../../components/VerArchivo";

import ListadoContext from "../context/ListadoContext";
import { withTools } from "../../helper/withTools";
import InputOnSubmit from "./columnas/InputOnSubmit";
import SelectOnSubmit from "./columnas/SelectOnSubmit";
import BotonWhatsapp from "../../components/Btnwsp";
import TextAreals from "../../components/TextAreals";
import InputBuscador from "../../VistaV2/components/columnas/InputBuscador/InputBuscador";

import SwitchCampos from "../../VistaV2/components/SwitchCampos";

const SwitchColumnas = ({
  data = {},
  cab,
  padre,
  indiceData,
  Context = ListadoContext,
  id_elemento,
  updateState,
}) => {
  const { opElegida } = useContext(ListadoContext);

  if (!cab) return <></>;
  const campokey = cab.campo_alias ? cab.campo_alias : cab.id_a;

  const hijos =
    cab.sc_hijos.length > 0
      ? cab.sc_hijos.map((s, i) => {
          const WrappedSwitchColumnas = withTools(SwitchColumnas);
          const WrappedSwitchCampos = withTools(SwitchCampos);
          const id_elemento = s.id_a + "_" + data.tableData?.id ?? i;
          if (["div", "columna_simple"].includes(cab.componente)) {
            return (
              <WrappedSwitchCampos
                key={s.id_a}
                data={data}
                cab={s}
                padre={cab}
                id_elemento={id_elemento}
              />
            );
          }
          return (
            <WrappedSwitchColumnas
              key={s.id_a}
              data={data}
              cab={s}
              padre={cab}
              id_elemento={id_elemento}
            />
          );
        })
      : null;

  if (data?.TOTALES === 1) {
    cab.componente = "columna_simple";
  }
  if (cab.round) {
    if (!isNaN(parseFloat(data[cab.id_a]))) {
      const val = Number(data[cab.id_a]);
      //.parseFloat(data[cab.id_a]).toFixed(parseInt(data[cab.id_a + "_round"] ?? cab.round));
      data[cab.id_a] = val;
    }
  }

  const Componente = (() => {
    // console.log("calculando componente", cab.id_a, cab.componente)
    if (cab.clave_envio && cab.clave_envio.trim() !== "") {
      data[cab.clave_envio] = data[campokey];
    }
    if (cab.hidden?.trim() === "s") return <></>;
    switch (data[`${cab.id_a}_COMPONENTE`] ?? cab.componente) {
      case undefined:
        return (
          <Default
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "":
      case "columna_simple":
        return (
          <Default
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "number":
        return (
          <Default
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
            number
          />
        );
      case "autocompletar":
        return (
          <Autocompletar
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            context={ListadoContext}
            id_elemento={id_elemento}
          />
        );
      case "boton":
        return (
          <Boton
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
            context={Context}
          />
        );
      case "input_buscador":
       // console.log("renderizando input buscador");
        return (
          <InputBuscador
            key={cab.id_a}
            data={data}
            cab={cab}
            context={Context}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
            valor={data[campokey]}
            updateid={data[cab.update_id_alias]}
          />
        );
      case "btn_wsp":
        return (
          <BotonWhatsapp
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "code":
        return (
          <Code
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "div":
        return (
          <div id={id_elemento} className={cab.className}>
            {hijos?.map((hijo) => hijo)}
          </div>
        );
      case "enlace":
        return (
          <Enlace
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "enlace_opcional":
        return (
          <EnlaceOpcional
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "enum":
        return (
          <SelectC
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
            updateState={updateState}
          />
        );
      case "fecha":
        return (
          <FechaC
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "grupo_columnas":
        return <>{hijos?.map((hijo) => hijo)}</>;
      case "imagen":
        return (
          <Imagen
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "input_editable":
        return (
          <InputAreaEditable
            key={cab.id_a}
            data={data}
            cab={cab}
            campokey={campokey}
            id_elemento={id_elemento}
            updateState={updateState}
            //hijos={hijos}
          />
        );
      case "input_fecha":
        return (
          <InputDate
            key={cab.id_a}
            data={data}
            cab={cab}
            campokey={campokey}
            id_elemento={id_elemento}
            updateState={updateState}
            //hijos={hijos}
          />
        );
      case "input_file":
        return (
          <InputFile
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "input_number_editable":
        return (
          <InputAreaEditable
            key={cab.id_a}
            data={data}
            cab={cab}
            campokey={campokey}
            id_elemento={id_elemento}
            updateState={updateState}
            type="number"
          />
        );
      case "input_onSubmit":
        return (
          <InputOnSubmit
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "input_text_editable":
        return (
          <InputTextEditable
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
            updateState={updateState}
          />
        );
      case "input_textarea":
        if (cab.tipo.id === 8) {
          return (
            <TextAreals
              key={cab.id_a}
              data={data}
              cab={cab}
              hijos={hijos}
              campokey={campokey}
              indiceData={indiceData}
              id_elemento={id_elemento}
              context={Context}
              updateState={updateState}
            />
          );
        }
        return (
          <TextAreals
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
            context={Context}
            updateState={updateState}
          />
        );
      case "null":
        return <></>;
      case "select":
        return (
          <SelectC
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
            updateState={updateState}
          />
        );
      case "select_onSubmit":
        return (
          <SelectOnSubmit
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "si_no":
        return (
          <SiNo
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "si_no_editable":
        return (
          <SiNoEditable
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
            updateState={updateState}
          />
        );
      case "textarea":
        return (
          <TextArea
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "toggle":
        return (
          <Toggle
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            updateState={updateState}
            id_elemento={id_elemento}
            opElegida={opElegida}
          />
        );
      case "ver_archivo":
        return (
          <VerArchivo
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
          />
        );
      default:
        return <>{hijos?.map((hijo) => hijo)}</>;
    }
  })();

  return Componente;
};
// export default withTools(SwitchColumnas);

const MemoizedSwitchColumnas = React.memo(withTools(SwitchColumnas));

export default MemoizedSwitchColumnas;
